import { render, staticRenderFns } from "./RateAndComment.vue?vue&type=template&id=76fc5767&scoped=true"
import script from "./RateAndComment.vue?vue&type=script&lang=js"
export * from "./RateAndComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fc5767",
  null
  
)

export default component.exports